import { render, staticRenderFns } from "./Tipotamponamento.vue?vue&type=template&id=287173db&"
import script from "./Tipotamponamento.vue?vue&type=script&lang=js&"
export * from "./Tipotamponamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports